<div class="d-flex flex-grow flex-column" style="height: 100%">
  <div class="kachel-title d-flex align-items-center">
    <i [class]="iconClass" style="margin-right: 4px; font-size: 18px"></i>
    <span>{{ title }}</span>
  </div>
  <div
    class="d-flex flex-grow flex-column dx-card wide-card rounded-kachel"
    [style]="cssStyles"
  >
    <ng-content class="d-flex flex-grow flex-column"></ng-content>
  </div>
</div>
